<template>
  <base-home-page logo="/capsiminbox/images/CapsimInbox_IAP_Logo_Colors.png">
    <login-form />
  </base-home-page>
</template>

<script>
  import LoginForm from './LoginForm.vue';
  import BaseHomePage from '@shared/BaseHomePage.vue';
  import { mapState } from 'vuex';

  export default {
    name: 'Home',

    components: {
      LoginForm,
      BaseHomePage,
    },

    watch: {
      authenticated: {
        immediate: true,
        handler(newStatus) {
          if (newStatus === true) {
            this.$router.push({ name: 'list-versions' });
          }
        },
      },
    },

    computed: {
      ...mapState('user', ['authenticated', 'actorKey', 'isAdmin']),
    },
  };
</script>
